<template>
  <div>
    <div class="container mt-4" v-if="errortype">
      <div class="alert alert-danger">{{ errortype | translate('msg') }}</div>
    </div>
    <form @submit.prevent="emitSave" id="packagediscountsAddEditDialogue" class="scrollable-container">
      <h4 class="mb-4">{{ (internalEdited ? 'EDIT' : 'ADD') | translate }}</h4>

      <div class="form-group" id="packagediscountsAddEditDialogue-formGroup-name">
        <label>{{ 'NAME' | translate }}
            <span class="asterisk">*</span>
        </label>
        <input type="text" class="form-control form-control-sm" v-model="packagediscounts.name" required maxlength="50"
          id="packagediscountsAddEditDialogue-formGroup-name-input">
      </div>

      <div class="form-group" id="packagediscountsTableAddEditDialog-formGroup-entry">
        <label>
          {{ 'No_Of_Policies' | translate }} &amp; {{ 'DiscountPercentage' | translate }}
          <span class="asterisk">*</span>
        </label>
        <div v-for="(entry, index) in packagediscounts.entries" :key="index"
          class="form-group position-relative d-flex align-items-center">
          <input type="text" class="form-control form-control-sm" v-model="entry.noOfPolicies"
            @input="updateEntry('noOfPolicies', index, $event.target.value)"
            :id="'packagediscountsTableAddEditDialog-noOfPolicies-input-' + index" style="flex-grow: 1;">
          <input type="text" class="form-control form-control-sm ml-2"
            v-model="entry.discountPercentage"
            @focus="handleDiscountFocus(entry)"
            @input="handleDiscountInput(entry, $event)"
            @blur="handleDiscountBlur(entry)"
            :id="'packagediscountsTableAddEditDialog-discount-input-' + index" style="flex-grow: 1;">
          <button type="button" @click="removeEntry(index)" aria-label="Remove Entry" class="btn btn-danger btn-sm ms-2">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>

      <button class="btn btn-link addnewstep" type="button" @click="addNewStep">
        {{ 'ADD_NEW_LINE' | translate }}
      </button>

      <div class="mt-4 text-right" id="packagediscountsAddEditDialogue-formGroup-buttons">
        <button class="btn btn-link closebtn" type="button" @click="emitClose"
          id="packagediscountsAddEditDialogue-closeButton">
          {{ 'CLOSE' | translate }}
        </button>
        <button class="btn btn-primary" type="submit" :disabled="!isFormValid"
          id="packagediscountsAddEditDialogue-addButton">
          {{ 'ADD' | translate }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import KeycloakService from '../../../service/keycloak/KeycloakService';
export default {
  props: ['edited', 'errortype'],
  data() {
    return {
      packagediscounts: {
        name: '',
        entries: []
      },
      internalEdited: false
    }
  },
  computed: {
    isFormValid() {
      const language = KeycloakService.getLanguage();
      const integerRegex = /^\d+$/;
      let doubleRegex;
      if (language === 'nl') {
        doubleRegex = /^-?\d{1,2},\d{2}$/;
      } else {
        doubleRegex = /^-?\d{1,2}\.\d{2}$/;
      }
      return (
        this.packagediscounts.entries.length > 0 &&
        this.packagediscounts.entries.every(entry => {
          const stepValid = entry.noOfPolicies.toString().trim() !== '' && integerRegex.test(entry.noOfPolicies.toString());
          const discountValid = entry.discountPercentage.toString().trim() !== '' && doubleRegex.test(entry.discountPercentage.toString());
          return stepValid && discountValid;
        })
      );
    }
  },
  methods: {
    emitSave() {
      const packageDiscountsClone = JSON.parse(JSON.stringify(this.packagediscounts));
      packageDiscountsClone.entries.forEach(entry => {
        let dpStr = entry.discountPercentage.toString();
        if (dpStr.includes(',')) {
          dpStr = dpStr.replace(/,/g, '.');
        }
        entry.discountPercentage = dpStr;
      });
      this.$emit(this.internalEdited ? 'update' : 'save', packageDiscountsClone);
    },
    emitClose() {
      this.$emit('close');
      this.resetPackageDiscounts();
    },
    resetPackageDiscounts() {
      this.packagediscounts = {
        name: '',
        entries: []
      };
      this.internalEdited = false;
    },
    updateEntry(field, index, value) {
      this.$set(this.packagediscounts.entries[index], field, value);
    },
    removeEntry(index) {
      this.packagediscounts.entries.splice(index, 1);
    },
    addNewStep() {
      const lang = KeycloakService.getLanguage();
      const defaultValue = lang === 'nl' ? '0,00' : '0.00';
      this.packagediscounts.entries.push({ noOfPolicies: '', discountPercentage: defaultValue });
    },
    handleDiscountFocus(entry) {
      // Clear the field if it contains the default value.
      const lang = KeycloakService.getLanguage();
      const defaultValue = lang === 'nl' ? '0,00' : '0.00';
      if (entry.discountPercentage === defaultValue) {
        entry.discountPercentage = '';
      }
    },
    handleDiscountInput(entry, event) {
      const lang = KeycloakService.getLanguage();
      const separator = lang === 'nl' ? ',' : '.';
      const input = event.target;
      let value = input.value;
      const originalPos = input.selectionStart;
      // Check if the user has just typed the separator.
      if (event.data === separator) {
        // If the value ends with the auto-appended default decimals (separator + "00"), remove them entirely.
        if (value.endsWith(separator + '00')) {
          const newValue = value.slice(0, -3); // Remove separator and "00"
          entry.discountPercentage = newValue;
          input.value = newValue;
          input.setSelectionRange(newValue.length, newValue.length);
          return;
        }
      }
      // If no separator is present and value is digits only, auto-append default decimals only if cursor is at end.
      if (value !== '' && !value.includes(separator) && /^\d+$/.test(value)) {
        if (originalPos === value.length) {
          const newValue = value + separator + '00';
          entry.discountPercentage = newValue;
          input.value = newValue;
          input.setSelectionRange(originalPos, originalPos);
          return;
        }
      }
      // Otherwise, update the model as typed.
      entry.discountPercentage = value;
    },
    handleDiscountBlur(entry) {
      const lang = KeycloakService.getLanguage();
      const separator = lang === 'nl' ? ',' : '.';
      const defaultValue = lang === 'nl' ? '0,00' : '0.00';
      if (!entry.discountPercentage || entry.discountPercentage.trim() === '') {
        entry.discountPercentage = defaultValue;
      } else if (entry.discountPercentage.indexOf(separator) === -1) {
        // If no separator, append the default decimal part.
        entry.discountPercentage = entry.discountPercentage + separator + '00';
      }
    }
  },
  watch: {
    edited(newVal) {
      if (newVal) {
        // Format discountPercentage to have two decimals.
        const formatDiscount = (value) => {
          const num = parseFloat(value);
          if (!isNaN(num)) {
            let formatted = num.toFixed(2);
            if (KeycloakService.getLanguage() === 'nl') {
              formatted = formatted.replace('.', ',');
            }
            return formatted;
          }
          return value;
        };

        this.packagediscounts = {
          code: newVal.code || null,
          name: newVal.name || '',
          entries: newVal.entries
            ? newVal.entries.map(entry => ({
              ...entry,
              discountPercentage: entry.discountPercentage
                ? formatDiscount(entry.discountPercentage)
                : (KeycloakService.getLanguage() === 'nl' ? '0,00' : '0.00')
            }))
            : [{ noOfPolicies: '', discountPercentage: KeycloakService.getLanguage() === 'nl' ? '0,00' : '0.00' }]
        };

        this.internalEdited = true;
      } else {
        this.resetPackageDiscounts();
      }
    }
  },
  created() {
    this.internalEdited = !!this.edited;
  }
}
</script>

<style lang="scss" scoped>
.asterisk {
  color: $danger;
}

>>>.vdp-datepicker__calendar {
  bottom: 30px;
}

.position-relative {
  position: relative;
}

.btn-danger {
  border: none;
  background-color: #dc3545;
  color: white;
  padding: 0.25rem 0.5rem;
}

.btn-danger:hover {
  background-color: #c82333;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.ms-2 {
  margin-left: 0.5rem;
}

.scrollable-container {
  max-height: 500px;
  overflow-y: auto;
  border-radius: 4px;
}

.addnewstep {
  margin-left: 5px;
}

.closebtn {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/PackageDiscounts/PackageDiscountsAddEditDialogue.vue